import { forwardRef } from 'react';

const FormInput = forwardRef(({ label, error, icon: Icon, required, className = '', ...props }, ref) => {
    return (
        <div className={className}>
            {label && (
                <label className="block text-sm font-medium text-slate-700 mb-1">
                    {label} {required && <span className="text-red-500">*</span>}
                </label>
            )}
            <div className="relative">
                {Icon && (
                    <div className="absolute inset-y-0 left-0 pl-3 flex items-center pointer-events-none">
                        <Icon className="w-5 h-5 text-slate-400" />
                    </div>
                )}
                <input
                    ref={ref}
                    className={`w-full rounded-xl border border-slate-200 text-sm text-slate-800 placeholder-slate-400 focus:border-emerald-700 focus:ring-2 focus:ring-emerald-700/20 transition ${Icon ? 'pl-10' : 'px-4'} py-2.5 ${error ? 'border-red-300 focus:border-red-500 focus:ring-red-500/20' : ''}`}
                    {...props}
                />
            </div>
            {error && <p className="mt-1 text-xs text-red-500">{error}</p>}
        </div>
    );
});

FormInput.displayName = 'FormInput';
export default FormInput;
